import _ from 'lodash';

var instance = null;

function FlexipanelCommon() {
    if (instance !== null) {
        throw new Error('Cannot instantiate more than one FilterCommon.');
    }
}

FlexipanelCommon.prototype.getMetricNameByKey = function (metrics, metricColKey) {
    if (_.isEmpty(metrics) || _.isEmpty(metricColKey)) {
        return;
    }

    var metric = _.find(metrics, ['columnKey', metricColKey]);

    return _.get(metric, 'columnDescription', null);
};

FlexipanelCommon.getInstance = function() {
    if (instance === null) {
        instance = new FlexipanelCommon();
    }
    return instance;
};

export default FlexipanelCommon.getInstance();
